import {
  QUERY_PROGRESS_FAILED,
  QUERY_PROGRESS_PENDING,
  QUERY_PROGRESS_SUCCEED,
  TRACK_EVENTS,
} from "core/consts";
import { onPremHttpRequest } from "core/model/careseekers";
import { QueryProgress } from "core/types";
import { useCallback } from "react";
import { useTracking } from "react-tracking";

export default function useSSLImport({
  on_premise_authorization_token,
  on_premise_domain_ssl,
  setImportStatus,
}: {
  on_premise_authorization_token: string | undefined;
  on_premise_domain_ssl: string | undefined;
  setImportStatus: React.Dispatch<React.SetStateAction<QueryProgress>>;
}) {
  const { trackEvent } = useTracking();

  const trackError = (reason: string) => {
    trackEvent({
      endpoint: on_premise_domain_ssl,
      name: TRACK_EVENTS.HL7_IMPORT_ERROR,
      reason,
    });
  };

  const trackImport = (status: number) => {
    trackEvent({
      endpoint: on_premise_domain_ssl,
      name: TRACK_EVENTS.HL7_PATIENT_IMPORT,
      status,
    });
  };

  const callImport = useCallback(
    async (
      externalId: string | undefined,
      onChangeKisHelper: (value: any) => void,
    ) => {
      setImportStatus(QUERY_PROGRESS_PENDING);
      try {
        const response = await onPremHttpRequest({
          method: "GET",
          on_premise_authorization_token,
          on_premise_domain_ssl,
          path: `patient/${externalId}`,
        });

        if (response) {
          trackImport(response.status);
          if (response.status === 200) {
            const payload = await response.json();
            onChangeKisHelper(payload);
            setImportStatus(QUERY_PROGRESS_SUCCEED);
          } else {
            onChangeKisHelper({ status: response.status });
            trackError("not found");
            setImportStatus(QUERY_PROGRESS_FAILED);
          }
        }
      } catch (err) {
        trackImport(-1);
        trackError("failed to fetch");
        console.log("Kis SSL Import error", err);
        setImportStatus(QUERY_PROGRESS_FAILED);
      }
    },
    [on_premise_domain_ssl],
  );

  return callImport;
}
